const IMAGE_PARAMS = 'auto=format&fit=crop&w=800&h=450&q=80';

export const SAFE_ITINERARY_FALLBACK =
  'https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1200&q=80';

const unsplash = (photoId, params = IMAGE_PARAMS) =>
  `https://images.unsplash.com/${photoId}?${params}`;

const CATEGORY_DEFAULTS = {
  hotel: [
    'photo-1566073771259-6a8506099945',
    'photo-1551882547-ff40c63fe5fa',
    'photo-1582719478250-c89cae4dc85b',
    'photo-1571896349842-33c89424de2d',
  ],
  restaurant: [
    'photo-1414235077428-338989a2e8c0',
    'photo-1517248135467-4c7edcad34c4',
    'photo-1504674900247-0877df9cc836',
    'photo-1559339352-11d035aa65de',
  ],
  flight: [
    'photo-1436491865332-7a61a109cc05',
    'photo-1464037866556-6812c9d1c72e',
    'photo-1556388158-158ea5ccacbd',
    'photo-1570710891163-6d3b5c47248b',
  ],
  car: [
    'photo-1449965408869-eaa3f722e40d',
    'photo-1485291571150-772bcfc10da5',
    'photo-1568605117036-5fe5e7bab0b7',
    'photo-1549317661-bd32c8ce0db2',
  ],
  train: [
    'photo-1474487548417-781cb71495f3',
    'photo-1515162816999-a0c47dc192f7',
  ],
  bus: [
    'photo-1570125909232-eb263c188f7e',
    'photo-1570125909517-53cb21c89ff2',
    'photo-1557223562-6c77ef16210f',
  ],
  ferry: [
    'photo-1548574505-5e239809ee19',
    'photo-1555881400-74d7acaacd8b',
    'photo-1569154941061-e231b4725ef1',
    'photo-1544551763-46a013bb70d5',
  ],
  activity: [
    'photo-1469854523086-cc02fe5d8800',
    'photo-1501785888041-af3ef285b470',
    'photo-1476514525535-07fb3b4ae5f1',
    'photo-1539635278303-d4002c07eae3',
  ],
  event: [
    'photo-1540575467063-178a50c2df87',
    'photo-1501281668745-f7f57925c3b4',
    'photo-1470229722913-7c0e2dbbafd3',
    'photo-1533174072545-7a4b6ad7a6c3',
  ],
  other: [
    'photo-1488646953014-85cb44e25828',
    'photo-1507525428034-b723cf961d3e',
    'photo-1476514525535-07fb3b4ae5f1',
    'photo-1501785888041-af3ef285b470',
  ],
};

const TRANSPORT_IMAGE_CATEGORY = {
  flight: 'flight',
  car_rental: 'car',
  taxi: 'car',
  uber: 'car',
  lyft: 'car',
  motorcycle: 'car',
  train: 'train',
  subway: 'train',
  bus: 'bus',
  ferry: 'ferry',
  cruise: 'ferry',
  walking: 'activity',
  bicycle: 'activity',
};

const hashSeed = (value) => {
  const str = String(value ?? '');
  let hash = 0;
  for (let index = 0; index < str.length; index += 1) {
    hash = ((hash << 5) - hash) + str.charCodeAt(index);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const isUsableImageUrl = (value) => {
  if (value == null) return false;
  const url = String(value).trim();
  if (!url || url === 'null' || url === 'undefined') return false;
  if (url.includes('source.unsplash.com') || url.includes('picsum.photos')) return false;
  return /^https?:\/\//i.test(url) || url.startsWith('/');
};

export const getItineraryImageCategory = (item = {}) => {
  const transportType = String(item.transportation_type || '').trim().toLowerCase();
  if (transportType && TRANSPORT_IMAGE_CATEGORY[transportType]) {
    return TRANSPORT_IMAGE_CATEGORY[transportType];
  }
  if (item.category === 'flight') return 'flight';
  if (item.category && CATEGORY_DEFAULTS[item.category]) {
    return item.category;
  }
  return 'other';
};

export const getDefaultItineraryItemImageUrl = (item = {}, params = IMAGE_PARAMS) => {
  const category = getItineraryImageCategory(item);
  const pool = CATEGORY_DEFAULTS[category] || CATEGORY_DEFAULTS.other;
  const seed = hashSeed(`${item.id ?? ''}|${item.name ?? ''}|${category}`);
  return unsplash(pool[seed % pool.length], params);
};

export const getItineraryItemImageUrl = (item, params = IMAGE_PARAMS) => {
  if (isUsableImageUrl(item?.image_url)) {
    return String(item.image_url).trim();
  }
  return getDefaultItineraryItemImageUrl(item, params);
};

export const THUMB_IMAGE_PARAMS = 'auto=format&fit=crop&w=400&h=300&q=80';
export const CARD_IMAGE_PARAMS = 'auto=format&fit=crop&w=900&h=400&q=80';
